import { render, staticRenderFns } from "./ctf-rich-text.vue?vue&type=template&id=b247f242&scoped=true&"
import script from "./ctf-rich-text.vue?vue&type=script&lang=js&"
export * from "./ctf-rich-text.vue?vue&type=script&lang=js&"
import style0 from "./ctf-rich-text.vue?vue&type=style&index=0&id=b247f242&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b247f242",
  null
  
)

export default component.exports